import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import './DeleteInstanceModal.css';
import {useTranslation} from 'react-i18next';

/**
 * Delete instance pop-up.
 * @param props
 * @constructor
 */
export default function DeleteInstanceModal(props: {
    open: boolean;
    handleClose: () => void;
    handleDelete: () => Promise<void>;
}) {
    const {i18n} = useTranslation();

    return (
        <Modal
            className={'modal-container'}
            open={props.open}
            onClose={props.handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box className={'box-container'}>
                <Typography
                    className={'modal-title'}
                    id="modal-modal-title"
                    variant="h6"
                    component="h2"
                >
                    {i18n.t('settings:deleteModal.title')}
                </Typography>
                <Typography id="modal-modal-description" sx={{mt: 2}}>
                    {i18n.t('settings:deleteModal.description')}
                </Typography>
                <div className={'modal-actions-container'}>
                    <Button
                        onClick={props.handleClose}
                        className={'delete-instance-button'}
                        variant="outlined"
                        size="small"
                    >
                        {' '}
                        {i18n.t('settings:deleteModal.cancel')}
                    </Button>
                    <div style={{width: '20px'}}> </div>
                    <Button
                        onClick={props.handleDelete}
                        color="error"
                        className={'delete-instance-button'}
                        variant="outlined"
                        size="small"
                    >
                        {' '}
                        {i18n.t('settings:deleteModal.delete')}
                    </Button>
                </div>
            </Box>
        </Modal>
    );
}
